import e, { useState as O, useRef as W } from "react";
import { useTranslation as Y } from "react-i18next";
import R from "../../../hooks/customization/useCustomization.js";
import { DottedSlider as S } from "../../../../../../features/common/components/sliders/DottedSlider/DottedSlider.js";
import { OrderButton as c } from "../OrderButton/OrderButton.js";
import { useOrdering as b } from "../context.js";
import l from "./steps.module.scss.js";
import g from "../../Restaurant/Restaurant.js";
import { RestaurantUrl as s } from "../../../shared/restaurant-url.enum.js";
import B from "../../../hooks/useOrderLater.js";
import { CallButton as A } from "../CallButton/CallButton.js";
function J() {
  const {
    currentStep: i,
    form: C,
    setStep: p,
    back: f
  } = b(), { restaurants: n } = i.data, h = n.filter(
    (t) => t.url[s.ONLY_TAKEAWAY]
  ), { t: v } = Y(), [a, N] = O(h[0]), _ = W(null), { isLoading: o, orderLater: k } = B(), {
    configuration: r,
    getTextTranslations: y
  } = R(), m = y("popup"), T = (t) => {
    N(n[t]);
  }, u = async (t) => {
    const d = await k(
      [t],
      i.data.service,
      C.place
    );
    p({
      name: "time-selector",
      data: d
    });
  }, E = async (t) => {
    p({
      name: "restaurant-redirection",
      data: {
        service: i.data.service,
        restaurant: t,
        now: !0
      }
    });
  }, w = () => {
    a !== void 0 && u(a);
  }, L = () => {
    a !== void 0 && E(a);
  };
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "restaurants-step" }, /* @__PURE__ */ e.createElement("div", { className: l.formTitle }, /* @__PURE__ */ e.createElement("i", { onClick: () => f(), className: "lni lni-chevron-left" }), (m == null ? void 0 : m.selector_title) || v("shopLanding.selector.title")), /* @__PURE__ */ e.createElement("div", { className: l.sliderWrapper }, /* @__PURE__ */ e.createElement(
    S,
    {
      ref: _,
      beforeChange: (t, d) => T(d),
      accentColor: r == null ? void 0 : r.design.colors.general.primaryButtonBackground,
      arrowTextColor: r == null ? void 0 : r.design.colors.general.secondaryButtonText,
      arrowBackgroundColor: r == null ? void 0 : r.design.colors.general.secondaryButtonBackground,
      showArrows: !0
    },
    // This is unfiltered as it was requested in SOF-4808
    n.map((t) => /* @__PURE__ */ e.createElement(
      g,
      {
        key: t.id,
        ...t,
        accent: (r == null ? void 0 : r.design.colors.general.highlightHighlight) ?? "#EA565C"
      }
    ))
  ), /* @__PURE__ */ e.createElement("div", { className: l.buttonContainer }, !a.url[s.ONLY_TAKEAWAY] && /* @__PURE__ */ e.createElement(A, { restaurant: a }), a.url[s.ONLY_TAKEAWAY] && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    c,
    {
      restaurant: a,
      type: "later",
      disabled: o,
      onClick: () => w()
    }
  ), /* @__PURE__ */ e.createElement(
    c,
    {
      restaurant: a,
      type: "now",
      disabled: o,
      onClick: () => L()
    }
  )))), /* @__PURE__ */ e.createElement(
    "div",
    { className: l.listWrapper },
    // This is unfiltered on purpose
    n.map((t) => /* @__PURE__ */ e.createElement("div", { key: t.id, className: l.listWrapper__item }, /* @__PURE__ */ e.createElement("div", { className: l.listWrapper__restaurant }, /* @__PURE__ */ e.createElement(
      g,
      {
        ...t,
        accent: (r == null ? void 0 : r.design.colors.general.highlightHighlight) ?? "#EA565C"
      }
    )), /* @__PURE__ */ e.createElement("div", { className: l.listWrapper__buttons }, !t.url[s.ONLY_TAKEAWAY] && /* @__PURE__ */ e.createElement(A, { restaurant: t }), t.url[s.ONLY_TAKEAWAY] && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      c,
      {
        restaurant: t,
        type: "now",
        disabled: o,
        onClick: () => E(t)
      }
    ), /* @__PURE__ */ e.createElement(
      c,
      {
        restaurant: t,
        type: "later",
        disabled: o,
        onClick: () => u(t)
      }
    )))))
  ));
}
export {
  J as default
};
//# sourceMappingURL=RestaurantsStep.js.map
